export const INVITATION_ACCEPT_REQUEST = 'INVITATION_ACCEPT_REQUEST'
export const INVITATION_ACCEPT_SUCCESS = 'INVITATION_ACCEPT_SUCCESS'
export const INVITATION_ACCEPT_ERROR = 'INVITATION_ACCEPT_ERROR'
export const INVITATION_ACCEPT_RESET = 'INVITATION_ACCEPT_RESET'
